import menu from './menu';
import label from './label';
import permission from './permission';
import title from './title';
import phrase from './phrase.json';

export default {
  menu,
  label,
  permission,
  title,
  phrase
};
